<div class="unavailable-slot-dialog d-flex flex-wrap justify-content-center align-items-center theme-interface">
    <div class="selection-container p-4 position-absolute">
        <div class="header-container d-flex flex-wrap ">
            <div class="font-size-header mt-3 mt-md-0 pb-4 font-weight-bold theme-color-header">
                {{'public.checkout.errors.orderSubmissionFailed' |
                translate}}</div>
            <span
                class="float-right position-absolute closebutton text-decoration-underline mb-2 mb-md-0 font-weight-bold theme-color-header"
                (click)="dismisssDialog()">{{'public.global.close'
                | translate}}<i class="fas fa-times pl-2 theme-color-header"></i></span>
        </div>
        <div class="body-container pb-2">
            {{'public.store.time.closed'| translate}}
            <div class="font-size-primary text-center pt-3 text-unselectable">
                <button type="button" class="btn theme-dark btn-dark px-5 py-1" (click)="dismisssDialog()">
                    {{ 'public.dialog.ok' | translate }}
                </button>
            </div>
        </div>
    </div>
</div>